import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { HEART_RATE, SHORT } from '../constants'

export function formatHeartRate ({ ...rest }) {
  return formatUnit({ ...rest, from: HEART_RATE, to: HEART_RATE, unit: SHORT })
}

export function heartRateFormatter ({ intl, locale, system }) {
  return ({ ...options }) => formatHeartRate({ ...options, intl, locale, system })
}

export class FormattedHeartRate extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([HEART_RATE]),
    to: PropTypes.oneOf([HEART_RATE]),
  };

  static defaultProps = {
    from: HEART_RATE,
    to: HEART_RATE,
    unit: SHORT,
  }

  render () {
    return React.createElement(FormattedUnit, { ...this.props, to: HEART_RATE, from: HEART_RATE })
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/heartRate.js